import { render, staticRenderFns } from "./AdminTaskCosec.vue?vue&type=template&id=78e01d92"
import script from "./AdminTaskCosec.vue?vue&type=script&lang=js"
export * from "./AdminTaskCosec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports